export default "__VITE_ASSET__CMg0Kd0A__"